import React, {useRef, useState, useEffect} from "react";
import {Stack, View} from "@unibuddy/patron";
import {ScrollView} from "react-native";

import {slidesImages} from "ubcommunity-shared/src/Auth/Landing/slidesImages";
import {SlidesItem} from "ubcommunity-shared/src/Auth/Landing/SlidesItem";

export const AuthLayout = ({children}: {children: React.ReactNode | undefined}) => {
    const [width, setWidth] = useState(0);
    const scrollViewRef = useRef<ScrollView>();
    const containerRef = useRef<unknown>();
    const widthRef = useRef<number>();

    const getListSize = () => {
        const newWidth = containerRef?.current?.clientWidth;
        setWidth(newWidth);
        widthRef.current = newWidth;
    };

    useEffect(() => {
        if (width === 0) {
            getListSize();
        }
        window.addEventListener("resize", getListSize);
        return () => window.removeEventListener("resize", getListSize);
    }, [width]);

    useEffect(() => {
        let currentSlide = 0;
        const timer = setInterval(() => {
            const newCurrentSlide = currentSlide + 1 < slidesImages.length ? currentSlide + 1 : 0;
            const newSlidePosition = widthRef.current * newCurrentSlide;

            scrollViewRef.current.scrollTo({
                animated: true,
                x: newSlidePosition,
            });
            currentSlide = newCurrentSlide;
        }, 5000);
        return () => clearInterval(timer);
    }, [scrollViewRef, widthRef]);

    return (
        <View flex="1" maxH="100%" flexDirection="row">
            <View flex={2} ref={containerRef}>
                <ScrollView
                    horizontal
                    pagingEnabled={true}
                    showsHorizontalScrollIndicator={false}
                    contentContainerStyle={{
                        width: width,
                    }}
                    scrollEnabled={false}
                    ref={scrollViewRef}
                    scrollEventThrottle={10}
                >
                    {slidesImages.map((image, index) => (
                        <SlidesItem
                            image={image}
                            width={width}
                            key={`landing-page-image-${index}`}
                        />
                    ))}
                </ScrollView>
            </View>
            <View
                justifyContent="center"
                minW={["100%", 375]}
                backgroundColor="white"
                flex={1}
                alignItems="center"
            >
                <View width="100%" padding="medium">
                    <Stack space="medium">{children}</Stack>
                </View>
            </View>
        </View>
    );
};
